.list {
    --tab-border-color: var(--mantine-color-default-border);
}

.tab {
    font-size: var(--mantine-font-size-sm);
    font-weight: 500;
    color: var(--mantine-color-dimmed);
    transition:
        color 120ms ease,
        background-color 120ms ease;
}

.tab:hover {
    color: var(--mantine-color-text);
}

.tab[data-active] {
    color: var(--mantine-color-text);
}

.tab[data-variant='default']:hover {
    --tab-hover-color: transparent;
}

.tabSection {
    color: inherit;
}

/* Pill tabs used by settings lists: users/groups, project access,
   scheduled deliveries, and custom roles. */
.root[data-variant='pills'] .list {
    gap: 0.5rem;
}

.root[data-variant='pills'] .tab {
    padding: 0.5rem 1rem;
    border-radius: var(--mantine-radius-md);
    border: 1px solid;
    border-color: light-dark(
        var(--mantine-color-ldGray-3),
        var(--mantine-color-dark-4)
    );
    color: var(--mantine-color-ldGray-7);
    background-color: light-dark(
        var(--mantine-color-white),
        var(--mantine-color-background-0)
    );
    transition:
        background-color 150ms ease,
        border-color 150ms ease,
        color 150ms ease;
}

.root[data-variant='pills'] .tab:hover {
    border-color: light-dark(
        var(--mantine-color-ldGray-4),
        var(--mantine-color-dark-3)
    );
    background-color: light-dark(
        var(--mantine-color-ldGray-0),
        var(--mantine-color-dark-6)
    );
    color: var(--mantine-color-ldGray-7);
}

.root[data-variant='pills'] .tab[data-active] {
    background-color: light-dark(
        var(--mantine-color-ldGray-9),
        var(--mantine-color-dark-5)
    );
    border-color: light-dark(
        var(--mantine-color-ldGray-9),
        var(--mantine-color-dark-4)
    );
    color: var(--mantine-color-white);
}

.root[data-variant='pills'] .tab[data-active]:hover {
    background-color: light-dark(
        var(--mantine-color-ldGray-8),
        var(--mantine-color-dark-4)
    );
    border-color: light-dark(
        var(--mantine-color-ldGray-8),
        var(--mantine-color-dark-3)
    );
    color: var(--mantine-color-white);
}

.root[data-variant='pills'] .panel {
    padding-top: 1rem;
}
